import {
  TeacherGetMyLiveClassesQueryVariables,
  TeacherInsertStudentsForLiveClassMutationVariables,
  TeacherMeetingCreateMutationVariables,
  TeacherMeetingDeleteMutationVariables,
  TeacherMeetingJoinMutationVariables,
} from '@school_ify/schoolify-repository/src/teacher/types';
import { StudentStudentGetMyLiveClassByMyIdQueryVariables } from '@school_ify/schoolify-repository/src/student/types';
import { GetLiveClassDetailsByIdQueryVariables } from '@school_ify/schoolify-repository/src/shared/types';
import { getLessons } from '@school_ify/schoolify-repository/src/shared/repositories/lessonRepository';
import {
  getMyLiveClasses,
  insertAttendees,
} from '@school_ify/schoolify-repository/src/teacher/repositories/liveClassRepository';
import { getLiveClassByID } from '@school_ify/schoolify-repository/src/shared/repositories/liveClassRepository';
import {
  createLiveClass,
  teacherDeleteMeeting,
  teacherJoinMeeting,
} from '@school_ify/schoolify-repository/src/teacher/repositories/meetingRepository';
import { studentGetLiveClasses } from '@school_ify/schoolify-repository/src/student/repositories/meetingRepository';

export default class LiveClass {
  public async teacherGetLessons() {
    const date = new Date();
    const month = date.getMonth();
    const day = date.getDay();
    const year = date.getFullYear();
    return getLessons({
      date: `${year}-${month}-${day}`,
    });
  }

  public async getClassDetails(variables: GetLiveClassDetailsByIdQueryVariables) {
    const liveClass = await getLiveClassByID(variables);
    return liveClass;
  }

  public async teacherGetLiveClasses(variables: TeacherGetMyLiveClassesQueryVariables) {
    return getMyLiveClasses(variables);
  }

  public async addAttendeesToClass(variables: TeacherInsertStudentsForLiveClassMutationVariables) {
    const insertedAddendees = await insertAttendees(variables);
    return insertedAddendees;
  }

  public async teacherCreateMeeting(variables: TeacherMeetingCreateMutationVariables) {
    const createdLiveSclass = await createLiveClass(variables);
    return createdLiveSclass;
  }

  public async teacherJoinMeeting(variables: TeacherMeetingJoinMutationVariables) {
    const joinedMeetings = await teacherJoinMeeting(variables);
    return joinedMeetings;
  }

  public async teacherDeleteMeeting(variables: TeacherMeetingDeleteMutationVariables) {
    const teacherDeletedMeeting = await teacherDeleteMeeting(variables);
    return teacherDeletedMeeting;
  }

  public async getClassStudents(variables: StudentStudentGetMyLiveClassByMyIdQueryVariables) {
    return studentGetLiveClasses(variables);
  }
}
